const amlTraining = {
  amlCertifiedTraining: 'AML Certified Training',
  correctAnswers: 'Correct answers',
  downloadCerticate: 'Download certificate',
  nextLesson: 'Next lesson',
  notarizeQuiz: 'Notarize quiz',
  notarizeVideoWatch: 'Notarize video watch',
  passed: 'Passed',
  requestCertificate: 'Request certificate',
  takeCertificate: 'Take certificate',
  takeCourse: 'Take course',
  takeQuiz: 'Take quiz',
  trainingCompleted:
    'Congratulations, you have successfully completed the learning and obtained the certificate.',
  watchVideo: 'Watch video',
};

export default amlTraining;
